import { createAction } from 'redux-actions';

import types from './types';

const loadAddresses = createAction(types.LOAD_ADDRESSES);
const loadBillingAddresses = createAction(types.LOAD_BILLING_ADDRESSES);
const setAddresses = createAction(types.SET_ADDRESSES);
const setStoredAddressId = createAction(types.SET_STORED_ADDRESS_ID);

export default {
    loadAddresses,
    loadBillingAddresses,
    setAddresses,
    setStoredAddressId,
};
